// Fichier de configuration centralisé : toutes les pages lisent ces valeurs.
export const SITE = {
  name: "O'RIZON 360",
  baseline: "Rénovation et entretien d'immeubles en Île-de-France",
  domain: "orizon360.site",
  url: "https://orizon360.site",
  legalForm: "Société par Actions Simplifiée Unipersonnelle (SASU)",
  legalFormShort: "SASU",
  capital: "500,00 €",
  address: {
    street: "8 Rue Lequesne",
    postalCode: "94130",
    city: "Nogent-sur-Marne",
    country: "France",
    full: "8 Rue Lequesne, 94130 Nogent-sur-Marne, France",
    lat: 48.8366,
    lng: 2.4826,
  },
  domiciliation: { name: "LEWIS & CO", rcs: "978 133 700" },
  rcs: "103 979 795 R.C.S. Créteil",
  rcsCity: "Créteil",
  siren: "103 979 795",
  siret: "103 979 795 00011",
  euid: "FR9401.103979795",
  ape: "4399C",
  apeLabel: "Travaux de maçonnerie générale et gros œuvre de bâtiment",
  tva: "FR 07 103979795",
  registrationDate: "22 avril 2026",
  activityStartDate: "14 avril 2026",
  companyDuration: "jusqu'au 21 avril 2125",
  fiscalYearEnd: "31 décembre",
  firstFiscalYearEnd: "31 décembre 2027",
  cmaDate: "6 août 2026",
  president: { fullName: "Mohamed Liamine LABED", legalName: "Monsieur LABED Mohamed Liamine", title: "Président" },
  activity:
    "Travaux de rénovation et d'entretien d'immeubles comprenant la maçonnerie, l'étanchéité, l'isolation et l'installation d'équipements techniques.",
  phone: { display: "07 58 48 12 47", international: "+33 7 58 48 12 47", href: "tel:+33758481247" },
  email: "equipe@orizon360.site",
  hours: [
    { days: "Lundi – Vendredi", hours: "8h00 – 18h00" },
    { days: "Samedi", hours: "9h00 – 12h00 sur rendez-vous" },
    { days: "Dimanche et jours fériés", hours: "Fermé" },
  ],
  serviceArea: [
    { name: "Nogent-sur-Marne", code: "94", main: true },
    { name: "Val-de-Marne", code: "94" },
    { name: "Paris", code: "75" },
    { name: "Hauts-de-Seine", code: "92" },
    { name: "Seine-Saint-Denis", code: "93" },
    { name: "Val-d'Oise", code: "95" },
    { name: "Yvelines", code: "78" },
    { name: "Essonne", code: "91" },
    { name: "Seine-et-Marne", code: "77" },
  ],
  cities94: [
    "Nogent-sur-Marne", "Le Perreux-sur-Marne", "Fontenay-sous-Bois", "Vincennes", "Saint-Maur-des-Fossés",
    "Champigny-sur-Marne", "Joinville-le-Pont", "Bry-sur-Marne", "Créteil", "Maisons-Alfort", "Charenton-le-Pont",
    "Saint-Mandé", "Ivry-sur-Seine", "Vitry-sur-Seine", "Villejuif", "Choisy-le-Roi", "Alfortville", "Boissy-Saint-Léger",
  ],
  insurance: {
    insurer: "AXA France IARD",
    policy: "n° 1234567",
    coverage: "France métropolitaine",
    note: "Attestations fournies sur simple demande.",
    toConfirm: true,
  },
  mediator: {
    name: "CM2C — Centre de Médiation de la Consommation de Conciliateurs de Justice",
    address: "14 rue Saint Jean, 75017 Paris",
    phone: "01 89 47 00 14",
    email: "cm2c@cm2c.net",
    website: "www.cm2c.net",
    url: "https://www.cm2c.net",
  },
  host: {
    name: "Namecheap, Inc.",
    address: "4600 East Washington Street, Suite 305, Phoenix, AZ 85034, États-Unis",
    phone: "+1 661 310 2107",
    website: "namecheap.com",
  },
  quoteValidityDays: 30,
  responseDelay: "48 heures ouvrées",
  payment: "30 % d'acompte à la signature du devis, paiements intermédiaires selon l'avancement des travaux, solde à la réception des travaux.",
  vatRates: [
    { rate: "20 %", label: "taux normal" },
    { rate: "10 %", label: "travaux d'amélioration / entretien d'un logement achevé depuis plus de 2 ans" },
    { rate: "5,5 %", label: "rénovation énergétique, sous conditions" },
  ],
  legalUpdateDate: "1er juin 2026",
};

export const NAV = [
  { to: "/", label: "Accueil" },
  { to: "/services", label: "Services" },
  { to: "/realisations", label: "Réalisations" },
  { to: "/a-propos", label: "À propos" },
  { to: "/contact", label: "Contact" },
];

export const LEGAL_NAV = [
  { to: "/mentions-legales", label: "Mentions légales" },
  { to: "/conditions-generales-de-vente", label: "CGV" },
  { to: "/conditions-generales-utilisation", label: "CGU" },
  { to: "/politique-de-confidentialite", label: "Politique de confidentialité" },
];

// En production sur Namecheap (sans backend) : laisser REACT_APP_BACKEND_URL vide pour utiliser les scripts PHP.
const backend = process.env.REACT_APP_BACKEND_URL;
export const ENDPOINTS = {
  devis: backend ? `${backend}/api/devis` : "/send-devis.php",
  contact: backend ? `${backend}/api/contact` : "/send-contact.php",
};
